<template>
  <svg class="mediator"
       :class="{ [`mediator--${type}`]: true }"
       width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.74635 13.1303C4.02036 13.1586 3.27736 13.0115 2.63826 12.5682C1.92663 12.0739 1.505 11.337 1.3235 10.551C0.742549 8.03679 0.910079 5.34264 2.10367 2.89291C2.42802 2.22689 2.96643 1.65546 3.68781 1.31451C4.40919 0.973558 5.18768 0.922909 5.89974 1.09948C8.51947 1.74857 10.6657 3.35066 12.1946 5.41791C12.6717 6.06343 12.9588 6.86446 12.8743 7.73428C12.7992 8.51424 12.4238 9.17817 11.9444 9.73083C10.3412 11.5795 7.21975 13.0328 4.74635 13.1303Z" fill="currentColor"/>
  </svg>
</template>

<script>
  export default {
    props: {
      type: { type: String, default: 'normal', validator: prop => ['normal', 'failed', 'success'].indexOf(prop) > -1 }
    }
  }
</script>

<style lang="scss">
  .mediator {
    display: inline-block;
    height: 1em;
    width: 1em;
  }

  .mediator--normal {
    color: $color-cyan !important;
  }

  .mediator--success {
    color: $color-green !important;
  }

  .mediator--failed {
    color: $color-red !important;
  }
</style>
